<template>
  <mds-modal actionRequired="true" aria-label="Upload Modal" v-model:visible="toggle" width="100%">
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="toggle = !toggle" :disabled="showModelLoader" variation="icon-only"
        icon="remove">Close</mds-button>
    </mds-button-container>
    <FileUpload v-if="toggle" :eventIdProp="eventIdProp" :uploadedDetails="uploadedDetails"
      :eventNameProp="eventNameProp" @showModelLoader="handleshowModelLoader" @updateDetails="handleUpdateDetails">
    </FileUpload>
  </mds-modal>
  <mds-modal aria-label="Loader Modal" actionRequired="true" v-model:visible="showModelLoader" size="small"
    style="width: 7%; height: auto; background-color: white; border: 0px">
    <ModelLoader></ModelLoader>
  </mds-modal>
  <mds-alert v-if="showAlert" v-bind:variation="alertVariation" v-bind:title="alertTitle" tinted
    @mds-alert-dismissed="closeAlert">
    {{ alertMessage }}
  </mds-alert>
  <!-----------CommentModalToggle Comment Modal Section ---------->

  <mds-modal style="width: 20%;padding: 5px;" actionRequired="true" aria-label="Upload Modal" v-model:visible="CommentModalToggle"
    width="40%">
    <div style="display: flex; flex-direction: column; gap: 10px;">    
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="CommentModalToggle = !CommentModalToggle" :disabled="showModelLoader"
        variation="icon-only" icon="remove">Close</mds-button>
    </mds-button-container>
    <textarea v-model="commentText" placeholder="Enter your comment here" style="width: 100%; height: 100px; padding: 10px; border-radius: 4px;border: 1px solid #ccc; font-size: 0.8rem; font-family: inherit; color: #333; white-space: pre-wrap;
      word-wrap: break-word; overflow-wrap: break-word; overflow-x: hidden; resize: none; box-sizing: border-box;"
      @input="commentText = commentText.replace(/[^a-zA-Z0-9\s,.-]/g, '')">
      </textarea>
    <mds-button-container style="margin-bottom: 0.5%; text-align: end">
      <mds-button type="button" @click="OnCommentSubmit" :disabled="showModelLoader"
        variation="primary">Submit</mds-button>
    </mds-button-container>
    </div>
  </mds-modal>

  <!-----------CommentModalToggle Comment Modal Section ---------->

  <mds-card style="width: 100%; margin-top: 1%; min-height: 80vh;" title="Conference Call Tracker"
    caption="Select Filter and View Conference Call Details here">
    <template #mds-card-action>
      <mds-form>
         <mds-fieldset id="fsFilter" style="display: flex; flex-wrap: wrap; gap: 1rem;margin-bottom: 10px;">
          <mds-input
            style="min-width:120px"
            id="inComapnyId"
            label="Company Id"
            v-model="CompanyId"
          ></mds-input>
          <mds-input
            style="min-width:120px"
            id="inEventId"
            label="Event Id"
            v-model="EventId"
          ></mds-input>
          <mds-combo-box
            label="EventType"
            multiple
            v-model="selectecEventTypes"
            :data-set="[
              { text: 'Brokers/Investment bank Call', value: '5' },
              { text: 'First Quarter Earnings Conference Call', value: '12' },
              { text: 'Second Quarter Earnings Conference Call', value: '13' },
              { text: 'Third Quarter Earnings Conference Call', value: '14' },
              { text: 'Fourth Quarter Earnings Conference Call', value: '15' },
              { text: 'Sales Call', value: '16' },
              { text: 'Analyst/Investor Day or meet', value: '17' },
              { text: 'Strategic/Management update Call', value: '18' },
              { text: 'M&A/Spin-off Call', value: '19' },
              { text: 'Q1 Guidance Call', value: '20' },
              { text: 'Q2 Guidance Call', value: '21' },
              { text: 'Q3 Guidance Call', value: '22' },
              { text: 'Q4 Guidance Call', value: '23' },
              { text: 'Other Guidance Call', value: '24' },
              { text: 'Fireside chats', value: '25' },
              { text: 'Roadshow Calls', value: '26' },
              { text: 'Capital Markets Day', value: '27' },
              { text: 'Other Conference call', value: '28' },
              { text: 'Annual General Meeting', value: '29' },    
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Priority"
            multiple
            v-model="Priority"
            :data-set="[
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '99', value: '99' },
              { text: 'NA', value: 'NA' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="FFPriority"
            multiple
            v-model="FFPriority"
            :data-set="this.FFPriorityList"
          ></mds-combo-box>
          <mds-date-picker
            style="min-width:150px"
            label="Begin Date"
            v-model="StartDate"
            :min-max-dates="{
              min: new Date(2000, 0, 1),
              max: new Date(2099, 11, 31)
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-date-picker
            style="min-width:150px"
            label="End Date"
            v-model="EndDate"
            :min-max-dates="{
              min: new Date(2000, 0, 1),
              max: new Date(2099, 11, 31)
            }"
            :labels="{ month: 'short' }"
            :date-format="{ month: 'short' }"
            readonly
          ></mds-date-picker>
          <mds-combo-box
            label="Replay Available"
            multiple
            v-model="IsReplayAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Presentation Available"
            multiple
            v-model="IsPresentationAvailable"
            :data-set="[
              { text: 'Yes', value: 'true' },
              { text: 'No', value: 'false' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Collection Status"
            v-model="CollectionStatus"
            multiple
            :data-set="[
              { text: 'Pending', value: 'Pending' },
              { text: 'In Progress', value: 'Inprogress' },
              { text: 'Completed', value: 'Completed' },
            ]"
          ></mds-combo-box>
          <mds-combo-box
            label="Job Status"
            v-model="JobIdStatus"
            style="min-width:260px"
            multiple
            :data-set="[
              { text: 'JOB_CREATED', value: '1' },
              { text: 'JOB_CREATION_FAILED', value: '2' },
              { text: 'BATCH_JOB_SUBMITTED', value: '3' },
              { text: 'BATCH_JOB_SUBMISSION_FAILED', value: '4' },
              { text: 'AUDIO_CONVERSION_SKIPPED', value: '5' },
              { text: 'AUDIO_CONVERSION_COMPLETED', value: '6' },
              { text: 'AUDIO_CONVERSION_FAILED', value: '7' },
              { text: 'AUDIO_RECORDER_COMPLETED', value: '8' },
              { text: 'AUDIO_RECORDER_FAILED', value: '9' },
              { text: 'WHISPER_GET_RESPONSE_RECEIVED', value: '10' },
              { text: 'WHISPER_GET_RESPONSE_FAILED', value: '11' },
              { text: 'PYANNOTE_DIARIZATION_COMPLETED', value: '12' },
              { text: 'PYANNOTE_DIARIZATION_FAILED', value: '13' },
              { text: 'TRANSCRIPTION_PROCESSOR_SUCCESS', value: '14' },
              { text: 'TRANSCRIPTION_PROCESSOR_FAILED', value: '15' },
            ]"
          ></mds-combo-box>
             <mds-combo-box label="Note Types" v-model="NoteType" multiple :data-set="[
              { text: 'Technical Issue', value: 'TechnicalIssue' },
              { text: 'Historical Audio', value: 'HistoricalAudio' },
              { text: 'Live Recorded', value: 'LiveRecorded' },
              { text: 'Only Dial In', value: 'OnlyDialIn' },
              { text: 'No Webcast', value: 'NoWebcast' },
              { text: 'Blocked by Zscaler', value: 'BlockedByZscaler' },
              { text: 'Call Cancelled', value: 'CallCancelled' },
              { text: 'Audio Expired', value: 'AudioExpired' },
              { text: 'Other', value: 'Other' }
            ]"></mds-combo-box>
        </mds-fieldset>
        <div style="display: flex;">
        <mds-button
          size="medium"
          variation="primary" icon="search" 
          v-on:click.prevent="getEvents(true)"
        >
          Search
        </mds-button>

        <mds-button style="margin-left: 10px" size="medium" variation="primary" icon="refresh"
          v-on:click.prevent="refreshEvent()">
          Refresh
        </mds-button>
        <mds-button style="margin-left: 10px" size="medium" variation="primary" icon="download"
          v-on:click.prevent="exportEvents()">
          Export
        </mds-button>
      </div>
      </mds-form>
      <div>
        <mds-loader
          size="large"
          aria-label="Large Loader"
          v-if="showLoader"
        ></mds-loader>
        <mds-pagination
          v-if="showPagination"
          show-items-info
          show-items-select
          :total-items="totalRecord"
          @mds-pagination-page-changed="handlePageChange"
          :pageSizes="paginationPageSize"
          :page="paginationOptions.page"
        ></mds-pagination>
        <div style="overflow-x: auto; width: 100%;">
          <div style="min-width: 1800px;">
        <mds-table zebra-stripes>
          <mds-thead>
            <mds-th style="width: 5%"> Event Id </mds-th>
            <mds-th style="width: 8%"> Event Name </mds-th>
            <mds-th style="width: 9%"> Company Id </mds-th>
            <mds-th style="width: 7%"> Event Type </mds-th>
            <mds-th style="width: 9%"> Beginning Date
              <button @click="getSortedData($event)" value="beginingDateDesc"><img
                  src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14" /></button>
              <button @click="getSortedData($event)" value="beginingDateAsc"><img
                  src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14" /></button></mds-th>
            <mds-th style="width: 5%"> Time </mds-th>
            <mds-th style="width: 7%"> IST DateTime 
              <button @click="getSortedData($event)" value="istDateDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="istDateAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 7%"> Priority 
              <button @click="getSortedData($event)" value="priorityDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="priorityAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 4%"> FFPriority </mds-th>
            <mds-th style="width: 5%"> Replay Available </mds-th>
            <mds-th style="width: 5%"> Event Details URL </mds-th>
            <mds-th style="width: 5%"> Webcast URL </mds-th>
            <mds-th style="width: 13%"> Source of Webcast 
            <button @click="getSortedData($event)" value="domainDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="domainAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 10%"> Collection Status </mds-th>
            <mds-th style="width: 8%"> JobId </mds-th>
            <mds-th style="width: 9%"> Job Status 
              <button @click="getSortedData($event)" value="jobStatusDesc"><img src="@/assets/icons/icons8-desc-sort-arrow.png" width="12" height="14"/></button>
              <button @click="getSortedData($event)" value="jobStatusAsc"><img src="@/assets/icons/icons8-asc-sort-arrow.png" width="12" height="14"/></button></mds-th>
            <mds-th style="width: 5%"> Action </mds-th>
            <mds-th style="width: 9%"> PPT Doc Id </mds-th>
            <mds-th style="width: 20%"> Edit DocId </mds-th>
            <mds-th style="width: 10%"> Note </mds-th>
          </mds-thead>
          <mds-tbody>
            <mds-tr v-for="(event, eventItemIndex) in eventList" :key="event.userid">
              <mds-td> {{ event.eventId }} </mds-td>
              <mds-td> {{ event.eventName }} </mds-td>
              <mds-td> {{ event.companyId }} </mds-td>
              <mds-td> {{ event.eventType }} </mds-td>
              <mds-td> {{ formatDate(event.beginingDate) }} </mds-td>
              <mds-td> {{ event.time }} </mds-td>
              <mds-td> {{ formatISTDate(event.istDate) }} </mds-td>
              <mds-td> {{ event.priority }} </mds-td>
              <mds-td> {{ event.ffPriority }} </mds-td>
              <mds-td>
                {{
                  event.isReplayAvailable == true
                    ? "Yes"
                    : event.isReplayAvailable == false
                      ? "No"
                      : event.isReplayAvailable
                }}
              </mds-td>
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.eventDetailUrl"
                  @click="openUrl(event.eventDetailUrl)"
                  v-if="event.eventDetailUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td
                ><a
                  style="cursor: pointer"
                  v-bind:title="event.webcastUrl"
                  @click="openUrl(event.webcastUrl)"
                  v-if="event.webcastUrl != ''"
                  >View Url</a
                ></mds-td
              >
              <mds-td> {{ event.domain }} </mds-td>
              <mds-td>
                <mds-select v-bind:value="event.collectionStatus" :id="collectionstatusId + eventItemIndex"
                  placeholder="Select an Option" :options="[
                    { text: 'In progress', value: 'Inprogress' },
                    { text: 'Pending', value: 'Pending' },
                    { text: 'Completed', value: 'Completed' },
                  ]"></mds-select>
              </mds-td>
              <mds-td style="word-wrap: break-word" :id="JobRowID + eventItemIndex">
                {{ event.jobId }}
              </mds-td>
              <mds-td style="word-wrap: break-word">
                {{ event.jobStatus }}
              </mds-td>


              <mds-td style="width: 42%">
                <label :class="$style['toggle-switch']">
                  <input type="checkbox" v-model="event.isEditing" />
                  <span :class="[$style.slider, $style.round]"></span>
                </label>
                <span style="margin-left: 8px;">{{ event.isEditing ? 'On' : 'Off' }}</span>
              </mds-td>



              <textarea v-model="event.textValue" :disabled="!event.isEditing" placeholder="Enter Doc IDs"
                @input="event.textValue = event.textValue.replace(/[^0-9,]/g, '')" style="
    width: 100%;
    height: 100px;
    padding: 10px;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-family: inherit;
    color: #333;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow-x: hidden;
    resize: none;
    box-sizing: border-box;"></textarea>


              <mds-td>
                <mds-table>
                  <mds-tr style="width: 100%">
                    <mds-td style="width: 20%">
                      <mds-button variation="primary"
                        v-on:click="saveStatus(eventItemIndex, event.eventId, event.textValue)"
                        size="small">Save</mds-button>
                    </mds-td>


                    <mds-td mds-td style="width: 40%">
                      <input type="File" :id="TranscribeFileInput + eventItemIndex" hidden ref="fileInput"
                        style="background-color: #e5e5e5; width: 70%" @change="handleFileChange" />
                      <mds-input :id="TranscribeFile + eventItemIndex" style="background-color: #e5e5e5; color: black"
                        placeholder="Choose Manual File" readonly v-on:click.prevent="chooseFiles(eventItemIndex)"
                        size="medium"></mds-input></mds-td>
                    <mds-td style="width: 40%">
                      <mds-button :id="TranscribeButton + eventItemIndex" variation="primary" v-on:click="
                        UploadTranscribe(
                          event.priority,
                          eventItemIndex,
                          event.eventId,
                          event.eventType,
                          event.companyId,
                          event.companyName,
                          event.beginingDate
                        )
                        " disabled size="small">Transcribe</mds-button>
                    </mds-td>
                  </mds-tr>
                </mds-table>
              </mds-td>
              <mds-td>
                <div class="hover-box">
                  <mds-select v-bind:value="event.commentNote" :id="NoteId + eventItemIndex"
                    @change="NoteChanged(event,eventItemIndex, event.eventId)" @mouseover="toggleTooltip(true,eventItemIndex, event.eventId)"
                    @mouseleave="toggleTooltip(false,eventItemIndex, event.eventId)" placeholder="Select an Option" :options="[
                      { text: 'Technical Issue', value: 'TechnicalIssue' },
                      { text: 'Historical Audio', value: 'HistoricalAudio' },
                      { text: 'Live Recorded', value: 'LiveRecorded' },
                      { text: 'Only Dial In', value: 'OnlyDialIn' },
                      { text: 'No Webcast', value: 'NoWebcast' },
                      { text: 'Blocked by Zscaler', value: 'BlockedByZscaler' },
                      { text: 'Call Cancelled', value: 'CallCancelled' },
                      { text: 'Audio Expired', value: 'AudioExpired' },
                      { text: 'Other', value: 'Other' }
                    ]"></mds-select>
                  <div :class="$style['tooltip']" :data-value="event.comment" :id="CommentId + eventItemIndex" v-if="showTooltip && showTooltipId == NoteId+eventItemIndex && event.commentNote === 'Other'">
                    {{event.comment}}
                  </div>
                </div>
              </mds-td>
            </mds-tr>
          </mds-tbody>
        </mds-table>
        </div>
        </div>
      </div>
    </template>
  </mds-card>
</template>

<script>
import axiosInstance from "@/AxiosTokenInstance";
import {
  MdsTable,
  MdsThead,
  MdsTh,
  MdsTbody,
  MdsTr,
  MdsTd,
} from "@mds/data-table-vue3";
import MdsForm from "@mds/form-vue3";
import MdsCard from "@mds/card-vue3";
import MdsComboBox from "@mds/combo-box-vue3";
import MdsInput from "@mds/input-vue3";
import MdsSelect from "@mds/select-vue3";
import MdsFieldset from "@mds/fieldset-vue3";
import { MdsButton } from "@mds/button-vue3";
import MdsDatePicker from "@mds/date-picker-vue3";
import { mapState, mapActions, mapMutations } from "vuex";
import MdsLoader from "@mds/loader-vue3";
import MdsPagination from "@mds/pagination-vue3";
import { ref, watch } from "vue";
import moment, * as moments from "moment";
import MdsModal from "@mds/modal-vue3";
import FileUpload from "../ConferenceCallTracker/FileUpload.vue";
import ModelLoader from "../ModelLoader.vue";
import MdsAlert from "@mds/alert-vue3";
import config from "../../config";
import { saveAs } from 'file-saver';
export default {
  name: "ConferenceCallDetails",
  components: {
    MdsCard,
    MdsForm,
    MdsComboBox,
    MdsSelect,
    MdsInput,
    MdsFieldset,
    MdsButton,
    MdsDatePicker,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsLoader,
    MdsPagination,
    FileUpload,
    MdsModal,
    ModelLoader,
    MdsAlert,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      paginationPageSize: [10, 20, 30, 40, 50, 100],
      eventList: [],
      showLoader: false,
      toggle: false,
      showTooltip: false,
      CommentModalToggle: false,
      showModelLoader: false,
      showTooltipId: "",
      commentText: "",
      eventIdProp: "",
      CompanyId: "",
      EventId: "",
      StartDate: "",
      EndDate: "",
      Priority: [],
      FFPriority: [],
      IsReplayAvailable: [],
      IsPresentationAvailable: [],
      CollectionStatus: [],
      Note: [],
      paginationOptions: {
        page: 1,
      },
      DefaultPageIndex: 1,
      DefaultPageSize: 10,
      totalRecord: "",
      collectionstatusId: "",
      NoteId: "NoteId",
      CommentId:"CommentId",
      EventStatus: {},
      EventComment: {},
      showAlert: false,
      alertTitle: "",
      alertMessage: "",
      alertVariation: "",
      uploadedDetails: [],
      webcastUrl: "",
      alertTimer: "",
      showPagination: false,
      TranscribeFile: "TranscribeFile",
      TranscribeFileInput: "TranscribeFileInput",
      TranscribeButton: "TranscribeButton",
      JobRowID: "JobRowID",
      selectedFile: null,
      chooseFile: "",
      currentFileIndex: 0,
      lastFileSelected: null,
      eventNameProp: "",
      selectecEventTypes: [],
      EventTypes: [],
      JobIdStatus: [],
      NoteType:[],
      sortInfo: "",
      sort:"",
      FFPriorityList:config.ffPriorityList.split(",").map(a => ({text:a,value:a})),
    };
  },
  mounted() {
    // this.getEventStatus(); this is Event Type API call on page load
    this.getEvents(false);
  },
  methods: {
    //Event Type API method
    getEventStatus() {
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/GetEventTypes", {})
        .then((response) => {
          if (response.data.success) {
            // console.log(response.data.data);
            response.data.data.map((item) => {
              this.EventTypes = {
                text: item.eventType,
                value: item.eventTypeId,
              };
            });
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error.response, "error");
        });
    },

    handleUpdateDetails(updatedDetails) {
      this.uploadedDetails = updatedDetails;
    },
    handleshowModelLoader(showModelLoader) {
      this.showModelLoader = showModelLoader;
    },
    refreshEvent() {
      window.location.reload(); // Reloads the current page
    },
    chooseFiles(index) {
      this.clearSelectedFile();
      if (this.lastFileSelected != null) {
        this.clearSelectedFiles();
        this.enabledisableUpload(this.lastFileSelected, true, "");
      }
      document.getElementById("TranscribeFileInput" + index).accept =
        config.audioFileType;

      this.currentFileIndex = index;
      document.getElementById("TranscribeFileInput" + index).click();
    },
    clearSelectedFiles() {
      this.selectedFile = null;
      this.chooseFile = "";
    },
    enabledisableUpload(buttonIndex, value, controlValue) {
      const button = document.getElementById("TranscribeButton" + buttonIndex);
      if (button !== null) {
        if (value == false) {

          const event = this.eventList[buttonIndex];
          if (this.isTranscribeAllowed(event)) {
            document.getElementById("TranscribeButton" + buttonIndex).disabled =
              value;
          }
          else {

            document.getElementById("TranscribeButton" + buttonIndex).disabled = true;

          }

        }
        if (value == true) {
          document.getElementById("TranscribeButton" + buttonIndex).disabled = value;
        }

        if (controlValue != "NA") {
          document.getElementById("TranscribeFile" + buttonIndex).value =
            controlValue;
        }
      }
    },
    isTranscribeAllowed(event) {
      let eventUTC = '';
      const currentUTC = this.getCurrentUTC();
      if (event.istDate == null)
        eventUTC = this.convertToUTC(event.beginingDate);
      else
        eventUTC = this.convertISTToUTC(event.istDate);
      return currentUTC >= eventUTC;
    },
    getCurrentUTC() {
      const now = new Date();
      return now.toISOString();
    },
    convertToUTC(inputDate) {
      if (!inputDate) {
        return null;
      }
      let validDate = inputDate.trim();
      if (!validDate.endsWith("Z")) {
        validDate += "Z";
      }


      const localDate = new Date(validDate);
      if (isNaN(localDate.getTime())) {
        return null;
      }
      return localDate.toISOString();

    },
    convertISTToUTC(istDate) {

      const eventDate = new Date(istDate);
      const utcDate = eventDate.toISOString();

      return utcDate;
    },
    async handleFileChange(event) {
      // Handle file selection
      this.selectedFile = event.target.files[0];

      if (this.selectedFile) {
        this.chooseFile = this.selectedFile.name;
        this.enabledisableUpload(this.currentFileIndex, false, this.chooseFile);
        this.lastFileSelected = this.currentFileIndex;
      }
      else {
        this.enabledisableUpload(this.currentFileIndex, true, "");
      }
    },


    clearSelectedFile() {

      if (this.lastFileSelected != null) {
        const fileInput = this.$refs.fileInput[this.lastFileSelected];
        if (fileInput) {
          fileInput.value = null;
        }
      }
    },
    getParams() {
  return {
    EventId: this.EventId,
    EventType: this.selectecEventTypes.length == 0 ? "" : this.selectecEventTypes.toString(),
    CompanyId: this.CompanyId,
    StartDate: this.StartDate,
    EndDate: this.EndDate,
    Priority: this.Priority.length == 0 ? "" : this.Priority.toString(),
    FFPriority: this.FFPriority.length == 0 ? "" : this.FFPriority.toString(),
    IsReplayAvailable: this.IsReplayAvailable.length == 0 ? "" : this.IsReplayAvailable.toString(),
    IsPresentationAvailable: this.IsPresentationAvailable.length == 0 ? "" : this.IsPresentationAvailable.toString(),
    CollectionStatus: this.CollectionStatus.length == 0 ? "" : this.CollectionStatus.toString(),
    JobStatus: this.JobIdStatus.length == 0 ? "" : this.JobIdStatus.toString(),
    NoteType: this.NoteType.length == 0 ? "" : this.NoteType.toString(),
    sort: this.sortInfo,
    sortColumn: this.sortColumn,
  };
},
    getEvents(resetpage) {
      this.showModelLoader = true;
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/EventDetails", {
          params: {
            ...this.getParams(),
            pageIndex: this.DefaultPageIndex,
            pageSize: this.DefaultPageSize
          },
        })
        .then((response) => {
          if (response.data.success) {
            this.eventList = response.data.data.eventList;
            this.totalRecord = response.data.data.totalRecords;

            if (this.totalRecord != 0) {
              if (resetpage) {
                this.paginationOptions.page = 1;
              }
              this.showPagination = true;
            } else {
              this.showPagination = false;
            }
            this.eventList.forEach((event) => {
              event.textValue = event.documentIds && Array.isArray(event.documentIds)
                ? event.documentIds.join(', ') // Convert documentIds array to a comma-separated string
                : ''; // If documentIds is not an array, set textValue as an empty string
              event.isEditing = false;
            });
          } else {
            this.setAlert(true, "Error Alert", response.data.message, "error");
          }
          this.showModelLoader = false;
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error.response, "error");
          this.showModelLoader = false;
        });
    },
    exportEvents(resetpage) {
      this.showModelLoader = true;
      axiosInstance
        .get(config.api_url + "ConferenceCallTracker/ExportToExcel", {
          responseType: 'blob',
          params: this.getParams(),
        })
        .then((response) => {

          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, 'ConferenceCallDetails.xlsx', {
            type: 'text/plain;charset=windows-1252'
          });
          this.showModelLoader = false;
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error.response, "error");
          this.showModelLoader = false;
        });
    },
    handlePageChange(paginationOptions) {
      this.paginationOptions = paginationOptions;
      this.DefaultPageIndex = paginationOptions.page;
      this.DefaultPageSize = paginationOptions.pageSize;
      this.eventList.forEach((event, index) => {
        this.enabledisableUpload(index, true, "");
      });
      this.getEvents(false);
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    toggleEdit(event) {
      event.isEditing = !event.isEditing;
    },
    toggleTooltip(show, eventItemIndex, eventId) {
      this.showTooltip = show;
      this.showTooltipId =  this.NoteId+eventItemIndex ;
    }
    ,
    openModel(eventId, webcastUrl, eventName) {
      this.toggle = !this.toggle;
      this.eventIdProp = eventId;
      this.eventNameProp = eventName;
      this.webcastUrl = webcastUrl;
      if (this.webcastUrl === null || this.webcastUrl === "") {
        this.webcastUrl = null;
      }
      this.showModelLoader = true;
      axiosInstance
        .get(
          `${config.api_url}ConferenceCallTracker/get-upload-data?eventId=${this.eventIdProp}&webcastUrl=${this.webcastUrl}`
        )
        .then((response) => {
          if (response.data.success)
            this.uploadedDetails = response.data.data.uploadedData;
          else
            this.setAlert(true, "Error Alert", response.data.message, "error");
        })
        .catch((error) => {
          this.setAlert(true, "Error Alert", error, "error");
        })
        .finally(() => {
          this.showModelLoader = false;
        });
    },

    formatDate(date) {
      var formatedDate = moment(date).format("YYYY-MM-DD");
      return formatedDate;
    },
    formatISTDate(datevalue) {
      if (datevalue) {
        var formatedISTDate = moment(datevalue).format("YYYY-MM-DD HH:mm:ss");
        return formatedISTDate;
      } else {
        return '';
      }
    },
    setComment() {

    }
    , setAlert(flag, tile, message, varation) {
      this.showAlert = flag;
      this.alertTitle = tile;
      this.alertMessage = message;
      this.alertVariation = varation;
      window.scrollTo(0, 0);
      if (flag) this.autoCloseAlert();
    },
    closeCommentModal() {

    },
    closeAlert() {
      this.setAlert(false, "", "", "");
      if (this.alertTimer) clearTimeout(this.alertTimer);
    },
    autoCloseAlert() {
      this.alertTimer = setTimeout(() => {
        this.closeAlert();
      }, config.alertTime * 1000);
    },
    async UploadTranscribe(
      priority,
      index,
      EventId,
      EventType,
      CompanyId,
      CompanyName,
      BeginingDate
    ) {
      // Validation 1: Select file
      if (this.selectedFile == "" || this.selectedFile == null) {
        this.setAlert(true, "Warning Alert", "Please Choose File", "warning");
        return;
      }
      // Validation 2: Only Audio and Video File
      if (this.selectedFile) {
        const arrfileExt = config.audioFileType.replaceAll(".", "").split(",");
        var ext = this.selectedFile.name.split(".").pop();
        if (!arrfileExt.includes(ext)) {
          this.setAlert(
            true,
            "Warning Alert",
            ext + " this file not supported, only allowed " + arrfileExt,
            "warning"
          );
          return;
        }
      }

      try {
        this.showModelLoader = true;
        const apiUrl = `${config.api_url}ConferenceCallTracker/transcribe`;
        const createdByValue = parseInt(this.userDetails.data.userId, 10);
        const formData = new FormData();
        formData.append("Priority", priority);
        formData.append("EventId", EventId);
        formData.append("EventType", EventType);
        formData.append("CompanyId", CompanyId);
        formData.append("CompanyName", CompanyName);
        formData.append("EventDate", BeginingDate);
        formData.append("FilePurpose", "audio_processing");
        formData.append("FileFormat", ext);
        formData.append("createdBy", createdByValue);
        formData.append("File", this.selectedFile);

        const response = await axiosInstance.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.success) {
          await this.getEvents(false);
          this.setAlert(true, "Success Alert", "Success", "success");
          this.showModelLoader = false;
        } else {
          this.setAlert(true, "Error Alert", response.data.message, "error");
          this.showModelLoader = false;
        }
      } catch (error) {
        this.setAlert(true, "Error Alert", error, "error");
        this.showModelLoader = false;
      } finally {
        if (this.connection) {
          this.clearSelectedFiles();
          await this.connection.stop();
        }
        this.clearSelectedFiles();
        this.enabledisableUpload(index, true, "NA");
      }
    },
    OnCommentSubmit() {
      if (this.commentText.trim() === "") {
        this.setAlert(true, "Warning Alert", "Please enter a comment.", "warning");
        return;
      }
      this.showModelLoader = true;

      const eventIndex = this.eventList.findIndex(e => e.eventId === this.EventComment.EventId);
            if (eventIndex !== -1) {
              this.eventList[eventIndex].comment = this.commentText;
              this.eventList[eventIndex].commentNote = "Other";
            }
      this.CommentModalToggle = false;

      this.showModelLoader = false;
      
    },
    ToggleCommentModal() {
      this.CommentModalToggle = !this.CommentModalToggle;
    },
    NoteChanged(event,index, EventId) {
      var selectedNote = document.getElementById(
        this.NoteId + index
      ).value;
      if (selectedNote == "" || selectedNote == null) { }
      else {
        
        this.EventComment.EventId = EventId;
        this.EventComment.CreatedBy = parseInt(this.userDetails.data.userId, 10);
        this.EventComment.Note = selectedNote;

        if (selectedNote == "Other") {
          this.commentText = "";
          this.ToggleCommentModal();

        }
        else {

          this.eventList[index].comment = "";
          this.eventList[index].commentNote = selectedNote;
        }
      }
    },
    saveStatus(index, EventId, DocumentIds) {
      this.closeAlert();
      var selectedStatus = document.getElementById(
        this.collectionstatusId + index
      ).value;

      if (selectedStatus == "" || selectedStatus == null)
        this.setAlert(
          true,
          "Warning Alert",
          "Please select Collection Status for Event Id :" + EventId,
          "warning"
        );
      else {
        const rawTextValue = DocumentIds || "";

        const documentIds = rawTextValue
          .split(",")
          .map(id => id.trim())
          .filter(id => id !== "")
          .map(id => {
            const parsed = parseInt(id, 10);
            return isNaN(parsed) ? null : parsed;
          });

        const uniqueIds = new Set(documentIds);
        if (uniqueIds.size !== documentIds.length) {
          this.setAlert(
            true,
            "Warning Alert",
            "Document IDs cannot contain duplicates.",
            "warning"
          );
          return;
        }
        if (documentIds.some(id => id === 0)) {
          this.setAlert(
            true,
            "Warning Alert",
            "Document ID cannot be zero.",
            "warning"
          );
          return;
        }

        this.EventStatus.EventId = EventId;
        this.EventStatus.CollectionStatus = selectedStatus;
        this.showModelLoader = true;
        this.EventStatus.DocumentIds = documentIds;
        this.EventStatus.CreatedBy = parseInt(this.userDetails.data.userId, 10);

        this.EventStatus.Comment = this.eventList[index].comment;
        this.EventStatus.Note = this.eventList[index].commentNote;

        axiosInstance
          .post(
            config.api_url + "ConferenceCallTracker/SaveEventStatus",
            this.EventStatus
          )
          .then((response) => {
            if (response.data.success) {
              if (response.data.data == "Validation")
                this.setAlert(
                  true,
                  "Warning Alert",
                  response.data.message,
                  "warning"
                );
              else
                this.setAlert(
                  true,
                  "Success Alert",
                  response.data.message,
                  "success"
                );
              this.eventList[index].isEditing = false;

            } else
              this.setAlert(
                true,
                "Error Alert",
                response.data.message,
                "error"
              );
            this.showModelLoader = false;
          })
          .catch((error) => {
            this.setAlert(true, "Error Alert", error.response, "error");
            this.showLoader = false;
          });

          
      }
    },
    getSortedData(event) {
      this.sortInfo = event.currentTarget.value.includes("Desc") ? "DESC" : "ASC";
      this.sortColumn = event.currentTarget.value.replace(/Desc|Asc/g, '').length > 1 ? event.currentTarget.value.replace(/Desc|Asc/g, '') : "beginingDate";
      this.getEvents(false);
    }
  },
  computed: {
    ...mapState("auth", {
      userDetails: (state) => state.userDetails,
    }),

    paginatedData() {
      const start = this.paginationOptions
        ? this.paginationOptions.firstItem - 1
        : 0;
      const end =
        this.paginationOptions && this.paginationOptions.pageSize !== -1
          ? start + this.paginationOptions.pageSize
          : this.eventList.length;
      return this.eventList.slice(start, end);
    },
  },
};
</script>
<style lang="scss" module>
*,
#fieldset1::before,
#fieldset1::after {
  margin-right: 15px;
}

.round {
  border-radius: 24px;
}

.round:before {
  border-radius: 50%;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    background-color: #ccc;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: 0.4s;
    border-radius: 24px;

    &::before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: 0.4s;
      border-radius: 50%;
    }
  }

  input:checked+.slider {
    background-color: #2196F3;

    &::before {
      transform: translateX(20px);
    }
  }
}

.doc-textarea:disabled {
  cursor: not-allowed;
  background-color: #f0f0f0;
}
.tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 5px;
  background-color: black;
  color: white;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 1000;
}
</style>
